import { ifCanPushDatalayer } from "./utils/utils.dataLayer.common";

const categorizeMarketoFormSubmission = (config) => {
    ifCanPushDatalayer({
        then: () => {
            const userEmail = config.userEmail;
            const payload = {
                event: "user_interaction",
                event_name: "generate_lead",
                user: {
                    user_status: config.userStatus,
                    submission_source: userEmail?.includes("coveo") ? "internal" : "external",
                    marketo_idf: config.marketoIDF
                },
                interaction: {
                    lead_type: config.leadType,
                    lead_step: "confirmation",
                }
            };

            if (config.useCase) {
                payload.calculator = {
                    name: config.useCase
                };
            }

            dataLayerBus.push(payload);
        },
    });
};

export default categorizeMarketoFormSubmission;
